/**
 * Entity model class
 *
 * This file is part of Minasa
 * (c) Kaden und Partner AG
 */
import BaseModel from './BaseModel';
import BaseCollection from './BaseCollection';

export class InterfaceValue extends BaseModel {
    defaults() {
        return {
            id: null,
            context: null,
            ident: null,
            display_value: null,
        };
    }

    mutations() {
        return {
            id: (id) => (Number(id) > 0 ? Number(id) : null),
        };
    }

    entityName() {
        return 'InterfaceValue';
    }
}

export class InterfaceValueCollection extends BaseCollection {
    options() {
        return {
            model: InterfaceValue,
        };
    }

    entityName() {
        return 'InterfaceValue';
    }
}
